document.addEventListener("DOMContentLoaded", function () {
  const toggleTitles = document.querySelectorAll(".app_toggle_tit");

  toggleTitles.forEach(titleEl => {
    titleEl.addEventListener("click", function () {              
      const content = this.nextElementSibling; 

      this.classList.toggle("active");
      content.classList.toggle("active");  
    });
  });

  const deviceWrap = document.querySelector(".device_fixed_wrap");
  const headerWrap =
    document.querySelector(".header-wrapper--border-bottom") ||
    document.querySelector(".header-wrapper");
  const triggerButtons =
    document.querySelector(".product__info-wrapper .product-form__buttons") ||
    document.querySelector(".product-form__buttons");

  function getTriggerPoint() {
    if (!triggerButtons) return 0;
    const rect = triggerButtons.getBoundingClientRect();
    return rect.bottom + (window.pageYOffset || document.documentElement.scrollTop || 0);
  }

  function updateDeviceWrapState() {
    const scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    const triggerPoint = getTriggerPoint();

    if (deviceWrap) {
      if (scrollY > triggerPoint) {
        deviceWrap.classList.add("active");
      } else {
        deviceWrap.classList.remove("active");
      }
    }

    if (headerWrap) {
      if (scrollY > 0) {
        headerWrap.classList.add("active");
      } else {
        headerWrap.classList.remove("active");
      }
    }
  }

  window.addEventListener("scroll", updateDeviceWrapState, { passive: true });
  window.addEventListener("resize", updateDeviceWrapState);
  window.addEventListener("load", updateDeviceWrapState);
  updateDeviceWrapState();

  document.querySelectorAll(".x2_app_video").forEach(function (container) {
    const video = container.querySelector("video");
    const playButton = container.querySelector(".x2_app_play");

    if (!video || !playButton) return;

    playButton.addEventListener("click", function () {
      video.play().then(function () {
        playButton.hidden = true;
      });
    });

    video.addEventListener("pause", function () {
      playButton.hidden = false;
    });
  });

  
});

$(function() {
  $('.sub-desc-wrap, .top_toggle').each(function(){
     var topDesc = $(this).find('.toggle_box');
     topDesc.addClass('collapsed').removeClass('show');
     topDesc.children('.hide').hide();
     topDesc.eq(0).removeClass('collapsed').addClass('show');
     topDesc.eq(0).children('.hide').css('display', 'block');
  });

     $('.sub-desc-wrap .toggle_box > .title, .top_toggle .toggle_box > .title').click(function(){
         var topDesc = $(this).closest('.sub-desc-wrap, .top_toggle').find('.toggle_box');
         var firstDesc = $(this).parents('.toggle_box:first');
         var firstHide = firstDesc.children('.hide');
         if(!firstHide.is(':visible')){
             topDesc.addClass('collapsed').removeClass('show');
             topDesc.children('.hide').stop(true, true).slideUp(100);
             firstDesc.removeClass('collapsed').addClass('show');
             firstHide.stop(true, true).slideDown(100);
         } else {
             firstDesc.removeClass('show').addClass('collapsed');
             firstHide.stop(true, true).slideUp(100);
         }
         return false;
     });



    $('.dis_wrap').each(function(){
      var bottomDesc = $(this).find('.toggle_box');
      bottomDesc.addClass('collapsed').removeClass('show');
      bottomDesc.children('.hide').hide();
      bottomDesc.eq(0).removeClass('collapsed').addClass('show');
      bottomDesc.eq(0).children('.hide').css('display', 'block');
    });

    var bottomDesc = $('.dis_wrap .toggle_box');
    var bottomDesc2 = $('.dis_wrap .toggle_box2');

     bottomDesc2.find('.hide').hide();
     bottomDesc2.addClass('collapsed');
     bottomDesc2.eq(0).removeClass('collapsed');
     bottomDesc2.eq(0).find('.hide:first').show();
    
    $('.dis_wrap .toggle_box .title').click(function(){
      var bottomDesc = $(this).closest('.dis_wrap').find('.toggle_box');
      var firstDesc = $(this).parents('.toggle_box:first');
      var firstHide = firstDesc.children('.hide');
      if(firstDesc.hasClass('collapsed') || firstHide.css('display') === 'none'){
        bottomDesc.addClass('collapsed').removeClass('show');
        bottomDesc.children('.hide').stop(true, true).slideUp(100);
        firstDesc.removeClass('collapsed').addClass('show');
        firstHide.stop(true, true).slideDown(100);
      } else {
        firstDesc.removeClass('show').addClass('collapsed');
        firstHide.stop(true, true).slideUp(100);
      }
      return false;
    });


    if($(window).width() < 768) {
      bottomDesc2.eq(0).find('.hide').hide();
      bottomDesc2.eq(0).addClass('collapsed');
      $('.dis_wrap .toggle_box2 .title').click(function(){
           var firstDesc = $(this).parents('.dis_wrap .toggle_box2:first');
             if(firstDesc.hasClass('collapsed')){
               bottomDesc.addClass('collapsed').removeClass('show');
               bottomDesc.find('.hide').slideUp(100);
               firstDesc.removeClass('collapsed').addClass('show');
               firstDesc.find('.hide').slideDown(100);
           } else {
               firstDesc.removeClass('show').addClass('collapsed');
               firstDesc.find('.hide').slideUp(100);
           }
           return false;
        
       });
    } else {
       $('.dis_wrap .toggle_box2 .title').click(function(){
           var firstDesc = $(this).parents('.dis_wrap .toggle_box2:first');
           if(firstDesc.hasClass('collapsed')){
               bottomDesc.addClass('collapsed').removeClass('show');
               bottomDesc.find('.hide').slideUp(100);
               firstDesc.removeClass('collapsed').addClass('show');
               firstDesc.find('.hide').slideDown(100);
           } else {
               firstDesc.removeClass('show').addClass('collapsed');
               firstDesc.find('.hide').slideUp(100);
           }
           return false;
       });
    }

      // Frequently Asked Question
     var article = $('.faq>.faqBody>.article');
     article.addClass('t_hide');
     article.find('.a').hide();
     article.eq(0).removeClass('t_hide');
     article.eq(0).find('.a').show();
     $('.faq>.faqBody>.article>.q>a').click(function(){
         var myArticle = $(this).parents('.article:first');
         if(myArticle.hasClass('t_hide')){
             article.addClass('t_hide').removeClass('show');
             article.find('.a').slideUp(100);
             myArticle.removeClass('t_hide').addClass('show');
             myArticle.find('.a').slideDown(100);
         } else {
             myArticle.removeClass('show').addClass('t_hide');
             myArticle.find('.a').slideUp(100);
         }
         return false;
     });

     var shortsSlide = new Swiper('.shorts-slide', {
            slidesPerView: 1.8, 
            spaceBetween: 10, 
            pagination: {
                el: ".short-pagination",
                type: "progressbar",
              },
            breakpoints: { 
             
              768: {
               
              },
              1024: {
                slidesPerView: 1.8,
              },
            }
      });
  
     var bodySlide = new Swiper('.body-slide', {
         slidesPerView: 1.2, 

       spaceBetween: 10, 
         pagination: {
             el: ".body-pagination",
             type: "progressbar",
           },
       observer: true,
      observeParents: true,
         breakpoints: { 
         
          
           1024: {
             slidesPerView: 2.3,
             spaceBetween: 20, 
           },
         }
   });

   var vitaSlide = new Swiper('.vita-slide', {
         slidesPerView: 1.2, 
         spaceBetween: 10, 
         autoHeight: true,
     
         breakpoints: { 
         
          1024: {
             slidesPerView: 1.5,
             spaceBetween: 20, 
           },
           
         }
   });

    var vitaSlide = new Swiper('.vita-slide2', {
            slidesPerView: 2.5, 
            spaceBetween: 10, 
            autoHeight: true,
        
            breakpoints: { 
            
             1024: {
                slidesPerView: 3.5,
                spaceBetween: 20, 
              },
              
            }
      });

      var vitaSlide = new Swiper('.vita-slide3', {
            slidesPerView: 2.5, 
            spaceBetween: 10, 
            autoHeight: true,
        
            breakpoints: { 
            
             1024: {
                slidesPerView: 3.5,
                spaceBetween: 20, 
              },
              
            }
      });

  var detailLogo1 = new Swiper('.detail_logo1', {
    slidesPerView: 2, 
    loop:true,
    speed:3000,
    autoplay:{
        delay : 0,
        disableOnInteraction : false,
    },
    allowTouchMove: true,
  breakpoints: { 

      769: {
       slidesPerView: 'auto', 
      },    
    }

});

  var detailLogo2 = new Swiper('.detail_logo2', {
    slidesPerView: 'auto', 
     centeredSlides: true,
   loop:true,
    autoplay:{
        delay : 2500,
        disableOnInteraction : false,
    },
    allowTouchMove: true,
    pagination: {
        el: ".logo-page",
        clickable: true,
      },
      navigation: {
        nextEl: ".logo-next",
        prevEl: ".logo-prev",
      },
    
  breakpoints: { 

      769: {
       slidesPerView: 'auto', 
      },    
    }

});

var deviceSlide = new Swiper('.device_slide', {
            slidesPerView: 'auto', 
            spaceBetween: 20, 
            slidesOffsetAfter:50,
               pagination: {
              el: ".device-page",
              clickable: true,
            },
            breakpoints: { 
            
             769: {
                slidesPerView: 4,
                spaceBetween: 25, 
                 slidesOffsetAfter:0,
              },
              
            }
      });

var allinoneSwiper = null;
function toggleAllinoneSwiper() {
  var selector = '.AllinOne .allinoneSwiper';
  if (!document.querySelector(selector)) return;

  if (window.innerWidth <= 768) {
    if (!allinoneSwiper) {
        allinoneSwiper = new Swiper(selector, {
          slidesPerView: 1,
          spaceBetween: 0,
          autoHeight: false,
          observer: true,
          observeParents: true,
          allowTouchMove: true,
        navigation: {
          nextEl: ".AllinOne .allinone_next",
          prevEl: ".AllinOne .allinone_prev",
        },
        pagination: {
          el: ".AllinOne .allinone-page",
          clickable: true,
        }
      });
    } else {
      allinoneSwiper.update();
    }
  } else if (allinoneSwiper) {
    allinoneSwiper.destroy(true, true);
    allinoneSwiper = null;
  }
}

toggleAllinoneSwiper();
window.addEventListener("resize", toggleAllinoneSwiper);

function getModeRealIndex(swiper) {
  if (!swiper) return 0;
  if (typeof swiper.realIndex === 'number') return swiper.realIndex;
  if (typeof swiper.activeIndex === 'number') return swiper.activeIndex;
  return 0;
}

function initModesSwiper(config) {
  var section = document.querySelector(config.sectionSelector);
  var swiperEl = section ? section.querySelector(config.swiperSelector) : null;
  var tabsWrap = section ? section.querySelector(config.tabsWrapSelector) : null;
  var tabsTrack = tabsWrap ? tabsWrap.querySelector(config.tabsSelector) : null;

  if (!section || !swiperEl || !tabsWrap || !tabsTrack) return null;

  var swiper = new Swiper(swiperEl, {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: false,
    autoHeight: config.autoHeight === true,
    allowTouchMove: true,
    observer: true,
    observeParents: true,
    navigation: {
      nextEl: config.nextSelector,
      prevEl: config.prevSelector
    },
    nextButton: config.nextSelector,
    prevButton: config.prevSelector,
    pagination: {
      el: tabsTrack,
      clickable: true,
      bulletClass: config.tabClass,
      bulletActiveClass: 'is-active',
      renderBullet: function (index, className) {
        return '<button type="button" class="' + className + '">' + config.labels[index] + '</button>';
      }
    }
  });

  var prevPaddle = null;
  var nextPaddle = null;

  function createPaddles() {
    if (prevPaddle || nextPaddle) return;

    prevPaddle = document.createElement('button');
    prevPaddle.type = 'button';
    prevPaddle.className = config.paddleClass + ' ' + config.paddlePrevClass;
    prevPaddle.setAttribute('aria-label', 'Previous mode tab');
    prevPaddle.innerHTML = '<span aria-hidden="true">&#8249;</span>';

    nextPaddle = document.createElement('button');
    nextPaddle.type = 'button';
    nextPaddle.className = config.paddleClass + ' ' + config.paddleNextClass;
    nextPaddle.setAttribute('aria-label', 'Next mode tab');
    nextPaddle.innerHTML = '<span aria-hidden="true">&#8250;</span>';

    prevPaddle.addEventListener('click', function() {
      swiper.slidePrev();
    });
    nextPaddle.addEventListener('click', function() {
      swiper.slideNext();
    });

    tabsWrap.appendChild(prevPaddle);
    tabsWrap.appendChild(nextPaddle);
  }

  function updateMobileState() {
    var modeTabs = tabsTrack.querySelectorAll('.' + config.tabClass);
    if (!modeTabs.length) return;

    tabsWrap.style.setProperty('--modes-tab-count', modeTabs.length);

    if (window.innerWidth > 1024) {
      tabsWrap.classList.remove('is-mobile-tabs', 'is-at-start', 'is-at-end');
      tabsWrap.style.setProperty('--modes-tabs-start', 0);
      tabsTrack.style.transform = '';
      return;
    }

    createPaddles();
    tabsWrap.classList.add('is-mobile-tabs');

    var visibleCount = 3;
    var activeIndex = getModeRealIndex(swiper);
    var maxStartIndex = Math.max(0, modeTabs.length - visibleCount);
    var startIndex = Math.max(0, Math.min(maxStartIndex, activeIndex - (visibleCount - 2)));
    var isAtStart = startIndex === 0;
    var isAtEnd = startIndex >= maxStartIndex;

    tabsWrap.style.setProperty('--modes-tabs-start', startIndex);
    tabsWrap.classList.toggle('is-at-start', isAtStart);
    tabsWrap.classList.toggle('is-at-end', isAtEnd);

    if (config.alignEndGap) {
      tabsTrack.style.transform = '';

      window.requestAnimationFrame(function() {
        if (getModeRealIndex(swiper) !== activeIndex) return;

        var wrapRect = tabsWrap.getBoundingClientRect();
        var endGap = 6;

        if (isAtEnd) {
          var lastTabRight = modeTabs[modeTabs.length - 1].getBoundingClientRect().right;
          var transform = window.getComputedStyle(tabsTrack).transform;
          var baseTransformX = transform === 'none' ? 0 : new DOMMatrixReadOnly(transform).m41;
          var targetTransformX = baseTransformX + (wrapRect.right - endGap - lastTabRight);
          tabsTrack.style.transform = 'translate3d(' + targetTransformX + 'px, 0, 0)';
        }
      });
    } else {
      tabsTrack.style.transform = '';
    }

    if (prevPaddle) prevPaddle.disabled = isAtStart;
    if (nextPaddle) nextPaddle.disabled = isAtEnd;
  }

  updateMobileState();
  swiper.on('slideChange', updateMobileState);
  swiper.on('slideChangeTransitionEnd', updateMobileState);
  window.addEventListener('resize', updateMobileState);

  return swiper;
}

var modeSwiper = initModesSwiper({
  sectionSelector: '.prdTxt100.threeModes',
  swiperSelector: '.modeSwiper',
  tabsWrapSelector: '.modes_tabs_wrap',
  tabsSelector: '.modes_tabs',
  nextSelector: '.prdTxt100.threeModes .modes_next',
  prevSelector: '.prdTxt100.threeModes .modes_prev',
  tabClass: 'modes_tab',
  paddleClass: 'modes_tabs_paddle',
  paddlePrevClass: 'modes_tabs_paddle_prev',
  paddleNextClass: 'modes_tabs_paddle_next',
  labels: ['Three Modes', 'Red', 'Blue', 'Purple']
});

var x2ThreeModesSwiper = initModesSwiper({
  sectionSelector: '.x2_three_modes',
  swiperSelector: '.x2_three_modes_swiper',
  tabsWrapSelector: '.x2_three_modes_tabs_wrap',
  tabsSelector: '.x2_three_modes_tabs',
  nextSelector: '.x2_three_modes .x2_three_modes_next',
  prevSelector: '.x2_three_modes .x2_three_modes_prev',
  tabClass: 'x2_three_modes_tab',
  paddleClass: 'x2_three_modes_tabs_paddle',
  paddlePrevClass: 'x2_three_modes_tabs_paddle_prev',
  paddleNextClass: 'x2_three_modes_tabs_paddle_next',
  autoHeight: true,
  alignEndGap: true,
  labels: ['Booster', 'Air Shot', 'Derma Shot', 'MC']
});

var newModeSection = document.querySelector('.prdTxt100.newMode');
var newModeSwiperEl = newModeSection ? newModeSection.querySelector('.newModeSwiper') : null;
var newModeTabsEl = newModeSection ? newModeSection.querySelector('.new_mode_tabs') : null;

if (newModeSection && newModeSwiperEl && newModeTabsEl) {
  var newModeSwiper = new Swiper(newModeSwiperEl, {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: false,
    allowTouchMove: true,
    observer: true,
    observeParents: true,
    navigation: {
      nextEl: '.newMode .new_mode_next',
      prevEl: '.newMode .new_mode_prev'
    },
    nextButton: '.newMode .new_mode_next',
    prevButton: '.newMode .new_mode_prev',
    pagination: {
      el: '.newMode .new_mode_tabs',
      clickable: true,
      bulletClass: 'new_mode_tab',
      bulletActiveClass: 'is-active',
      renderBullet: function(index, className) {
        var labels = ['Dual', 'Mask', 'AI'];
        return '<button type="button" class="' + className + '">' + labels[index] + '</button>';
      }
    }
  });

}

var clinicalResultsSwiper = initModesSwiper({
  sectionSelector: '.clinical_results',
  swiperSelector: '.clinicalResultsSwiper',
  tabsWrapSelector: '.clinical_results_tabs_wrap',
  tabsSelector: '.clinical_results_tabs',
  nextSelector: '.clinical_results .clinical_results_next',
  prevSelector: '.clinical_results .clinical_results_prev',
  tabClass: 'clinical_results_tab',
  paddleClass: 'clinical_results_tabs_paddle',
  paddlePrevClass: 'clinical_results_tabs_paddle_prev',
  paddleNextClass: 'clinical_results_tabs_paddle_next',
  alignEndGap: true,
  labels: ['Glow Boosting', 'Pore Refining', 'Skin Defining', 'Bounce Boosting']
});

var motionSlide = new Swiper('.motion_slide', {
            slidesPerView: 1, 
            spaceBetween: 0,  
            loop:true,    
             pagination: {
              el: ".motion-page",
              clickable: true,
            },
            navigation: {
              nextEl: ".motion-next",
              prevEl: ".motion-prev",
            },
    
      });      
var bnaSlide = new Swiper('.bna_slide', {
              slidesPerView: 1.2, 
            spaceBetween: 20, 
            slidesOffsetAfter:30,
             
              pagination: {
              el: ".bna-page",
              clickable: true,
            },
            breakpoints: { 
            
             769: {
                slidesPerView: 4,
                spaceBetween: 15,
                slidesOffsetAfter:0,
              },
              
            }
    
      });

var comSlide = new Swiper('.comment_slide', {
            slidesPerView: 1, 
            spaceBetween: 0,     
            loop:true,  
             pagination: {
              el: ".com-page",
              clickable: true,
            },
            navigation: {
              nextEl: ".com-next",
              prevEl: ".com-prev",
            },
    
      });

var howToUse = null;
var howToUseMobile = null;
function toggleHowToUseSwiper() {
  var desktopSelector = '.howtoSwiper';
  var mobileSelector = '.howtoMobileSwiper';
  var hasDesktop = !!document.querySelector(desktopSelector);
  var hasMobile = !!document.querySelector(mobileSelector);
  if (!hasDesktop && !hasMobile) return;

  if (window.innerWidth > 768) {
    if (howToUseMobile) {
      howToUseMobile.destroy(true, true);
      howToUseMobile = null;
    }
    if (!howToUse) {
      howToUse = new Swiper(desktopSelector, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: '.howToUse .howto_next',
          prevEl: '.howToUse .howto_prev'
        },
        // legacy swiper fallback keys
        nextButton: '.howToUse .howto_next',
        prevButton: '.howToUse .howto_prev',
        pagination: {
          el: '.howToUse .howto_tabs',
          clickable: true,
          bulletClass: 'howto_tab',
          bulletActiveClass: 'is-active',
          renderBullet: function (index, className) {
            var labels = ['How to use', 'How to charge'];
            return '<button type="button" class="' + className + '">' + labels[index] + '</button>';
          }
        }
      });
    } else {
      howToUse.update();
    }
  } else if (howToUse) {
    howToUse.destroy(true, true);
    howToUse = null;
  }

  if (window.innerWidth <= 768 && hasMobile) {
    if (!howToUseMobile) {
      howToUseMobile = new Swiper(mobileSelector, {
        slidesPerView: 1.3,
        spaceBetween: 24,
  
        observer: true,
        observeParents: true,
   
      });
    } else {
      howToUseMobile.update();
    }
  }
}

toggleHowToUseSwiper();
window.addEventListener("resize", toggleHowToUseSwiper);

  (function setupFullVideoDeviceScene() {
    var deviceSection = document.querySelector(".device_container");
    var deviceInner = deviceSection ? deviceSection.querySelector(".device_inner") : null;
    var deviceFlex = deviceInner ? deviceInner.querySelector(".device_inner_flex") : null;

    if (!deviceSection) return;

    var mobileMQ = window.matchMedia("(max-width: 768px)");
    var ticking = false;

    function clamp(value, min, max) {
      return Math.max(min, Math.min(max, value));
    }

    function updateScene() {
      var isMobile = mobileMQ.matches;
      var scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      var trackEl = deviceFlex || deviceSection;
      var trackRect = trackEl.getBoundingClientRect();
      var trackTopDoc = trackRect.top + scrollY;
      var trackHeight = trackEl.offsetHeight;
      var viewportH = window.innerHeight || document.documentElement.clientHeight || 0;

      // device_inner_flex 중심이 화면 중심에 왔을 때 애니메이션 완료
      var trackCenterDoc = trackTopDoc + (trackHeight * 0.5);
      var start = trackTopDoc - viewportH;
      var end = trackCenterDoc - (viewportH * 0.5);

      if (end <= start) {
        end = start + 1;
      }

      var linearProgress = clamp((scrollY - start) / (end - start), 0, 1);
      var progress = linearProgress * linearProgress * (3 - (2 * linearProgress)); // smoothstep
      var riseY = isMobile ? 0 : (1 - progress) * 140;
      var gapStart = isMobile ? 14 : 132;
      var gapEnd = isMobile ? 0 : 0;
      var scaleStart = isMobile ? 0.82 : 0.80;
      var scaleEnd = isMobile ? 1.10 : 1.12;
      var flexWidthStart = isMobile ? 100 : 40;
      var flexWidthEnd = isMobile ? 80 : 40;
      var gap = gapStart + ((gapEnd - gapStart) * progress);
      var scale = scaleStart + ((scaleEnd - scaleStart) * progress);
      var flexWidth = flexWidthStart + ((flexWidthEnd - flexWidthStart) * progress);

      deviceSection.style.setProperty("--device-rise-y", riseY.toFixed(2) + "px");
      deviceSection.style.setProperty("--device-gap", gap.toFixed(2) + "px");
      deviceSection.style.setProperty("--device-scale", scale.toFixed(3));
      deviceSection.style.setProperty("--device-flex-width", flexWidth.toFixed(2) + "%");
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        updateScene();
        ticking = false;
      });
    }

    window.addEventListener("scroll", requestUpdate, { passive: true });
    window.addEventListener("resize", requestUpdate);

    if (typeof mobileMQ.addEventListener === "function") {
      mobileMQ.addEventListener("change", requestUpdate);
    } else if (typeof mobileMQ.addListener === "function") {
      mobileMQ.addListener(requestUpdate);
    }

    updateScene();
  })();

var appSlide = new Swiper('.app_slide_inner', {
            slidesPerView: 1, 
            spaceBetween: 0,      
             pagination: {
              el: ".app-page",
              clickable: true,
            },
            navigation: {
              nextEl: ".app-next",
              prevEl: ".app-prev",
            },
            breakpoints: { 
            
             769: {
                slidesPerView: 4,
        
              },
              
            }
    
    
      });

 $(document).on('click', '.prd_plus', function() {
    var $gradient = $(this);
    var $target = $gradient.prev('.bna-slide-inner'); // 바로 이전 형제 요소 선택

    if ($target.length) {
      $target.toggleClass('open'); // open 클래스 토글
    }
  });


// Modal
var modals = document.getElementsByClassName("modal");
var btns = document.getElementsByClassName("modalBtn");
var spanes = document.getElementsByClassName("close");
var funcs = [];
 

function Modal(num) {
  return function() {
   
    btns[num].onclick =  function() {
        modals[num].style.display = "block";
        console.log(num);
    };

    spanes[num].onclick = function() {
        modals[num].style.display = "none";
    };
  };
}
 
for(var i = 0; i < btns.length; i++) {
  funcs[i] = Modal(i);
}
 
for(var j = 0; j < btns.length; j++) {
  funcs[j]();
}
 
window.onclick = function(event) {
  if (event.target.className == "modal") {
      event.target.style.display = "none";
  }
};

 });

function downloadPDF(pdfUrl) {
    fetch(pdfUrl)
        .then(response => response.blob()) 
        .then(blob => {
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = pdfUrl.split('/').pop().split('?')[0];
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(link.href); 
        })
        .catch(error => console.error("PDF 다운로드 오류:", error));
}



// PDF 다운로드 피씨
      document.querySelectorAll(".downloadLink").forEach(link => {
    link.addEventListener("click", function(event) {
        event.preventDefault(); // 기본 동작 방지

        const fileUrl = this.getAttribute("data-pdf"); 
        const fileName = fileUrl.split("/").pop().split("?")[0];

        fetch(fileUrl)
            .then(response => response.blob()) 
            .then(blob => {
                const downloadLink = document.createElement("a");
                downloadLink.href = URL.createObjectURL(blob);
                downloadLink.download = fileName;
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
            })
            .catch(error => console.error("파일 다운로드 오류:", error));
    });
});

// X2 슬라이드 바운스
 document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.x2_upgrade_media video, .x2_three_modes_slide_wrap video, .new_mode_slide_wrap video').forEach(function (video) {
      video.preload = 'auto';
      video.load();
    });

    document.querySelectorAll('.clinical_results img').forEach(function (image) {
      image.loading = 'eager';
      image.decoding = 'async';
    });

    var slideHints = [
      {
        trigger: document.querySelector('.x2_three_modes_slide_wrap'),
        target: document.querySelector('.x2_three_modes_swiper')
      },
      {
        trigger: document.querySelector('.new_mode_slide_wrap'),
        target: document.querySelector('.newModeSwiper')
      },
      {
        trigger: document.querySelector('.clinical_results'),
        target: document.querySelector('.clinicalResultsSwiper')
      }
    ];

    function playSlideHint(item) {
      if (item.hasPlayed || !item.target) {
        return;
      }

      item.hasPlayed = true;
      item.target.classList.add('x2_slide_hint');

      setTimeout(function () {
        item.target.classList.remove('x2_slide_hint');
      }, 2900);
    }

    function checkSlideHints() {
      slideHints.forEach(function (item) {
        if (!item.trigger || !item.target || item.hasPlayed) {
          return;
        }

        var rect = item.trigger.getBoundingClientRect();
        var previousTop = item.previousTop;

        item.previousTop = rect.top;

        var startLine = 300;

        if (previousTop > startLine && rect.top <= startLine) {
          playSlideHint(item);
        }
      });
    }

    slideHints.forEach(function (item) {
      if (!item.trigger) {
        return;
      }

      item.previousTop = item.trigger.getBoundingClientRect().top;
    });

    var ticking = false;

    window.addEventListener('scroll', function () {
      if (ticking) {
        return;
      }

      ticking = true;
      window.requestAnimationFrame(function () {
        checkSlideHints();
        ticking = false;
      });
    });

    checkSlideHints();
  });